"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _MMSR5JSJcjs = require('../__chunks/MMSR5JSJ.cjs');
require('../__chunks/FH6HQ5JN.cjs');


var _XWMMMXUKcjs = require('../__chunks/XWMMMXUK.cjs');
require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/collection/collection-provider.tsx
var _jsxruntime = require('react/jsx-runtime');
function CollectionProvider(props = {}) {
  const store = _MMSR5JSJcjs.useCollectionStore.call(void 0, props);
  return /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _XWMMMXUKcjs.CollectionContextProvider, { value: store, children: props.children });
}


exports.CollectionProvider = CollectionProvider;
